var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login",attrs:{"id":"okta-signin-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }